import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import WorkscoreShell from '../../components/workscore/WorkscoreShell';
import LanguageSelector from '../../components/ui/LanguageSelector';
import { getWorkscoreConfig } from '../../features/workscore/config';
import { translateStaticText } from '../../config/staticAssessmentTranslations';

export default function WorkscoreIntroPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const config = getWorkscoreConfig(slug);
  const [currentLanguage, setCurrentLanguage] = useState('en');

  if (!config) {
    return (
      <WorkscoreShell>
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="rounded-2xl border border-white/15 bg-white/5 p-6 text-center">{translateStaticText('Assessment not found.', currentLanguage)}</div>
        </div>
      </WorkscoreShell>
    );
  }

  const sectionTitles = config.sectionTitles.map((title) => translateStaticText(title, currentLanguage));

  return (
    <WorkscoreShell>
      <div className="mx-auto max-w-5xl px-4 py-10 md:py-16">
        <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-6 md:p-10">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-sm uppercase tracking-wider text-white/60">{translateStaticText('WorkScore Assessment', currentLanguage)}</p>
              <h1 className="mt-2 text-3xl md:text-4xl font-semibold">{config.title}</h1>
              <p className="mt-3 text-white/75">{translateStaticText(config.role, currentLanguage)}</p>
            </div>
            <LanguageSelector
              currentLanguage={currentLanguage}
              onLanguageChange={setCurrentLanguage}
              isTranslating={false}
            />
          </div>

          <div className="mt-6 grid gap-3 md:grid-cols-2">
            {sectionTitles.map((title, index) => (
              <div key={`${index}_${title}`} className="rounded-xl border border-white/10 bg-white/5 px-4 py-3">
                <p className="text-white/90 font-medium">{translateStaticText('Section', currentLanguage)} {index + 1}: {title}</p>
                <p className="text-xs text-white/60 mt-1">{translateStaticText('Pool: 50 | Asked', currentLanguage)}: {config.questionsPerSection || 10}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 grid gap-2 text-sm text-white/75">
            <p>{translateStaticText('Total Time: 90 minutes', currentLanguage)}</p>
            <p>{translateStaticText('Question Delivery: Random {n} per section from each 50-question pool', currentLanguage).replace('{n}', String(config.questionsPerSection || 10))}</p>
            <p>{translateStaticText('Scoring: Best 10 | Strong 7 | Average 4 | Weak 2 | Poor 0', currentLanguage)}</p>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={() => navigate(`/workscore/${slug}/instructions`)}
              className="rounded-xl px-5 py-3 font-semibold text-white"
              style={{ background: config.color }}
            >
              {translateStaticText('View Rules & Start', currentLanguage)}
            </button>
            <button
              type="button"
              onClick={() => navigate('/workscore')}
              className="rounded-xl border border-white/20 bg-white/10 px-5 py-3"
            >
              {translateStaticText('Back', currentLanguage)}
            </button>
          </div>
        </div>
      </div>
    </WorkscoreShell>
  );
}
